<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import McpServerForm from './McpServerForm.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();
const isSubmitting = ref(false);

const handleClose = () => emit('close');

const handleSubmit = async serverDetails => {
  if (isSubmitting.value) return; // Prevent double submission

  isSubmitting.value = true;

  try {
    await store.dispatch('mcpServers/create', serverDetails);
    useAlert(t('INTEGRATION_SETTINGS.MCP_SERVERS.MESSAGES.CREATE_SUCCESS'));
    handleClose();
  } catch (error) {
    let errorMessage = t(
      'INTEGRATION_SETTINGS.MCP_SERVERS.MESSAGES.CREATE_ERROR'
    );

    if (error?.response?.data?.errors) {
      const errors = error.response.data.errors;
      const firstError = Object.values(errors)[0];

      if (firstError?.code) {
        const validationKey = `INTEGRATION_SETTINGS.MCP_SERVERS.VALIDATION.${firstError.code}`;
        // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
        errorMessage = t(validationKey);
      } else if (firstError?.message) {
        errorMessage = firstError.message;
      }
    } else if (error?.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error?.message) {
      errorMessage = error.message;
    }

    useAlert(errorMessage);
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <div
    class="w-[25rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] p-6 rounded-xl border border-slate-50 dark:border-slate-900 shadow-md flex flex-col gap-6 max-h-[85vh] overflow-y-auto"
  >
    <h3 class="text-base font-medium text-slate-900 dark:text-slate-50">
      {{ t('INTEGRATION_SETTINGS.MCP_SERVERS.FORM.TITLE_CREATE') }}
    </h3>
    <McpServerForm
      mode="create"
      :show-modal-wrapper="false"
      :is-submitting="isSubmitting"
      @submit="handleSubmit"
      @cancel="handleClose"
    />
  </div>
</template>
